import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { AuthenticationService } from '../../services/authentication.service';
import { inject } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

export const refreshTokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthenticationService);

  if (
    request.url.includes('authentication/sign-in/refresh') ||
    request.url.includes('oauth2/authorization/google')
  ) {
    return next(request);
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return authService.refresh().pipe(
          switchMap(() => {
            return next(request);
          }),
          catchError((refreshError) => throwError(() => refreshError)),
        );
      }

      if (error.status === 403) {
        console.error('Accesso negato (403): eseguo il logout.');
        authService.logout();
      }

      return throwError(() => error);
    }),
  );
};
